<template>
  <v-layout row wrap pa-3>
    <v-flex xs12 md8 wrap>
      <v-layout column main-section>
        <v-flex pt-3>
          <v-card-title>
            <!-- <h3 class="halfwhite-text">
                {{ $store.getters.getHeadingForBalanceBlock }}
              </h3> -->
            <v-icon>mdi-tag-outline</v-icon>
            <h4 class="headline halfwhite-text ml-2">Store Transactions</h4>
          </v-card-title>
          <v-flex mt-4 mx-3>
            <StoreTransactions></StoreTransactions>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex></v-flex>
    <v-flex xs12 md3 px-3 mt-4 mr-2>
      <v-layout column wrap mt-4>
        <BalanceColumn></BalanceColumn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import BalanceColumn from "@/components/BalanceColumn";
import StoreTransactions from "@/components/StoreTransactions";

export default {
  name: "UserTransactions",
  components: {
    BalanceColumn,
    StoreTransactions,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  beforeMount() {},
};
</script>
